import { Outlet, useNavigate } from "react-router-dom";
import GlobalFooter from "./GlobalFooter";
import LeftBar from "./LeftBar";
import RoleSwitcher from "./RoleSwitcher";
import { useAuth } from "../context/AuthContext";

function Main() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout(); 
  };

  const handleProfileClick = () => {
    navigate('/profil');
  };

  const getUserInitials = (user: any) => {
    if (user?.prenom && user?.nom) {
      return `${user.prenom.charAt(0)}${user.nom.charAt(0)}`.toUpperCase();
    }
    return user?.email?.charAt(0).toUpperCase() || 'U';
  };

  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'ADMIN': return 'Administrateur';
      case 'PROPRIETAIRE': return 'Propriétaire';
      case 'USER': return 'Utilisateur';
      default: return 'Utilisateur';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar gauche */}
      <div className="fixed left-0 top-0 z-30">
        <LeftBar/>
      </div>

      {/* Contenu principal avec sidebar offset */}
      <div className="flex-1 ml-64 flex flex-col min-h-screen">
        
        {/* Header principal */}
        <header className="bg-white shadow-md border-b border-gray-200 sticky top-0 z-20">
          <div className="px-6 py-4 flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <h1 className="text-2xl font-bold text-gray-800">
                Tableau de Bord
              </h1>
              <div className="hidden md:flex items-center space-x-2">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  En ligne
                </span>
              </div>
            </div>
            
            {/* Actions du header */}
            <div className="flex items-center space-x-4">
              {/* Sélecteur de rôle */}
              
              <RoleSwitcher /> 
              
              {/* Menu utilisateur */}
              <div className="relative group">
                <div className="flex items-center space-x-3 cursor-pointer">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    <span className="text-white text-sm font-medium">
                      {getUserInitials(user)}
                    </span>
                  </div>
                  <div className="hidden md:block">
                    <div className="text-sm font-medium text-gray-700">
                      {user?.prenom} {user?.nom}
                    </div>
                    <div className="text-xs text-gray-500">
                      {getRoleLabel(user?.role || '')}
                    </div>
                  </div>
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>

                {/* Menu déroulant */}
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-200">
                  <div className="px-4 py-2 border-b border-gray-100">
                    <p className="text-sm font-medium text-gray-900">{user?.prenom} {user?.nom}</p>
                    <p className="text-xs text-gray-500">{user?.email}</p>
                  </div>
                  <button 
                    onClick={handleProfileClick}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                  >
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    Mon profil
                  </button>
                  <div className="border-t border-gray-100">
                    <button 
                      onClick={handleLogout}
                      className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                    >
                      Se déconnecter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Zone de contenu principal */}
        <main className="flex-1 overflow-auto">
          <div className="p-6">

            {/* Contenu dynamique (Outlet) */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 min-h-[calc(100vh-280px)]">
              <Outlet/>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-4 px-6 mt-auto">
          <GlobalFooter/>
        </footer>
      </div>
    </div>
  );
}
export default Main;